//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../MBD/MBD.WebRuleInstanceInput.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Values",0,"SelectNXObjectList",0]],[[["num_selection_types"],"GetSelectionTypes",{R_:{selection_types:""}},0,0],[[],"IsMultiSelection",{R_:{isMultiSelection:''}},0,0]],[]];
SPLM.MBD.WebRuleInstanceSelectionInput = class extends SPLM.MBD.WebRuleInstanceInput{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebRuleInstanceSelectionInput";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.WebRuleInstanceSelectionInput.SelectionType = Object.freeze({
    "Face" : "Face", "Datum" : "Datum", "Body" : "Body", "Edge" : "Edge", "Curve" : "Curve", "Dimension" : "Dimension", "Component" : "Component", "Point" : "Point", "PmiRegion" : "PmiRegion"});

export default SPLM;